
<div class="backspinner" *ngIf="mode === 'indeterminate'">
  <div class="spinner-border" role="status">
    <span class="sr-only">Loading...</span>
  </div>
</div>
<div class="signin-popup">
  <div class="signin-wrap" id="signin-wrap">
    <a  (click)="closecomponent()" class="close-btn cursorHand"><i class="icon-close"></i></a>
    <div class="popup-logo text-center">
      <a routerLink="/">
        <img src="https://www.mylifewell.com/assets/images/logo/300.png" alt="logo">
      </a>
    </div>
    <div class="global-error">
      <div class="invalid-feedback text-center" *ngIf="wrongPassword.length > 0" style="display: block; position:static;margin-bottom: 8px;">
        <div>{{wrongPassword}}</div>
      </div>
    </div>
    <form class="login-form" [formGroup]="loginForm">
      <div class="form-group">
        <input class="form-control" formControlName="email" type="text" placeholder="Email" [ngClass]="{ 'is-invalid': submitted &&  loginForm.controls.email.errors }" (keyup) = "keyUp($event)">
        <i class="icon-email"></i>
        <div *ngIf="submitted && loginForm.controls.email.errors" class="invalid-feedback">
          <div *ngIf="loginForm.controls.email.errors.required">
            Please enter your email address in the format yourname@example.com
          </div>
        </div>
        <div class="invalid-feedback" *ngIf="errorMsg.length>0">{{errorMsg}}</div>
        <div class="invalid-feedback" *ngIf="wrongPassword.length>0">{{wrongPassword}}</div>
      </div>
      <div class="form-group">
        <input class="form-control" formControlName="password" type="password" placeholder="Password"
               [ngClass]="{ 'is-invalid': submitted && loginForm.controls.password.errors }">
        <i class="icon-pwd"></i>
        <div *ngIf="submitted && loginForm.controls.password.errors" class="invalid-feedback">
          <div *ngIf="loginForm.controls.password.errors.required ">Password is required</div>
        </div>
      </div>
      <div class="forget-pwd" (click)="forgotPasswordClick()">
        <a  class="forget-link">
          Forgot Password ?
        </a>
      </div>

      <div class="buttons-wrap">
        <button type="submit" (click)="onSubmit()"  class="btn">Log In</button>
        <!-- <button *ngIf="!isRegisterPage" class="btn signup-btn" (click)="closecomponentandsignup()" >
          <span>
            Sign Up
          </span>
        </button> -->
      </div>
    </form>
  </div>
</div>
